import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EventEmitter from '../../../utilities/EventEmitter';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import { useLink } from 'react-router-stack';
import constants from '../../../constants';
import React from 'react';
import MyContestListMWeb from './index_mWeb';
import MyContestListWeb from './index_web';

const MyContestList = () => {
  const dispatch = useDispatch();
  const { myContestList: fantasyCricketMyContestList } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { myContestList: fantasyFootballMyContestList } = useSelector(
    (state: any) => state.fantasy_football
  );
  const navigate = useLink();
  const {
    gameType,
    item: matchItem,
    myTeamList = [],

    fantasyMatchClick
  } = useGame();

  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');
  const [error, setError] = useState(false);

  const totalTeamsCount = myTeamList.length;

  const { joined = false, tabType = 'FIXTURE', status: matchStatus = '', gameState } = matchItem;

  const [challenges, setChallenges] = useState([] as any);

  useEffect(() => {
    getMyJoinedContestAPI();
    EventEmitter.on('updateMyContests', getMyJoinedContestAPI_);
    return () => {
      EventEmitter.off('updateMyContests', getMyJoinedContestAPI_);
    };
  }, []);

  const getMyJoinedContestAPI_ = () => getMyJoinedContestAPI();

  const getMyJoinedContestAPI = async (skip = 0) => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketMyContestList[matchItem['_id']];
    } else if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballMyContestList[matchItem['_id']];
    }
    if (!error && result) {
      if (skip === 0) {
        setChallenges(result);
      } else {
        setChallenges((challenges: any): any[] => [...challenges, ...result]);
      }
      setError(false);
    } else {
      setError(true);
    }
  };

  const onPressCard = (contest: any, completed = false) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest,
          completed,
          joined,
          tabType,
          totalTeamsCount: totalTeamsCount
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const onPressShare = async () => {};

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  return (
    <>
      {isSmartPhone ? (
        <MyContestListMWeb
          challenges={challenges}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          gameState={gameState}
          gameType={gameType}
          matchStatus={matchStatus}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
        />
      ) : (
        <MyContestListWeb
          challenges={challenges}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          gameState={gameState}
          gameType={gameType}
          matchStatus={matchStatus}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
        />
      )}
    </>
  );
};

export default React.memo(MyContestList);
